<div class="flex justify-center px-4">
  <div class="container mx-auto">
    <div class="md:mt-32 mt-24 mx-auto">
      <div
        class="bg-white border border-gray-200 rounded-2xl p-6 md:p-10 space-y-8 text-gray-700 leading-relaxed"
      >
        <h2 class="text-3xl font-extrabold mb-8 text-gray-900">
          Terms & Conditions
        </h2>

        <p class="text-lg">
          By accessing or using our website, you agree to comply with the
          following terms and conditions.
        </p>

        <!-- User Responsibilities -->
        <div class="border-l-4 border-[var(--primary)] pl-4">
          <h3 class="text-xl font-semibold text-gray-800 mb-2">
            User Responsibilities
          </h3>
          <ul class="list-disc pl-6 space-y-2">
            <li>Provide accurate and up-to-date account information</li>
            <li>Keep your login credentials secure</li>
            <li>Use the platform in compliance with applicable laws</li>
          </ul>
        </div>

        <!-- Products and Services -->
        <div class="border-l-4 border-[var(--primary)] pl-4">
          <h3 class="text-xl font-semibold text-gray-800 mb-2">
            Products and Services
          </h3>
          <ul class="list-disc pl-6 space-y-2">
            <li>
              We sell merchandise including (but not limited to):
              <ul class="list-disc pl-6 mt-2 space-y-1">
                <li>T-shirts</li>
                <li>Mugs</li>
                <li>Tech-themed products</li>
              </ul>
            </li>
            <li>
              All product descriptions, images, and prices are subject to change
              at any time without notice.
            </li>
          </ul>
        </div>

        <!-- Pricing and Payment -->
        <div class="border-l-4 border-[var(--primary)] pl-4">
          <h3 class="text-xl font-semibold text-gray-800 mb-2">
            Pricing and Payment
          </h3>
          <ul class="list-disc pl-6 space-y-2">
            <li>All prices are listed in the applicable currency.</li>
            <li>We reserve the right to change prices at any time.</li>
            <li>Payments must be made through approved payment methods.</li>
            <li>Orders will only be processed after successful payment.</li>
          </ul>
        </div>

        <!-- Order Acceptance -->
        <div class="border-l-4 border-[var(--primary)] pl-4">
          <h3 class="text-xl font-semibold text-gray-800 mb-2">
            Order Acceptance and Cancellation
          </h3>
          <ul class="list-disc pl-6 space-y-2">
            <li>We reserve the right to accept or reject any order.</li>
            <li>
              Orders may be cancelled due to:
              <ul class="list-disc pl-6 mt-2 space-y-1">
                <li>Product unavailability</li>
                <li>Payment issues</li>
                <li>Incorrect pricing</li>
              </ul>
            </li>
            <li>If cancelled, you will receive a full refund.</li>
          </ul>
        </div>

        <!-- Intellectual Property -->
        <div class="border-l-4 border-[var(--primary)] pl-4">
          <h3 class="text-xl font-semibold text-gray-800 mb-2">
            Intellectual Property
          </h3>
          <ul class="list-disc pl-6 space-y-2">
            <li>
              All content on this website, including but not limited to logos,
              designs, text, and images, is the property of the company.
            </li>
            <li>
              You may not copy, reproduce, distribute, or reuse any content
              without prior written permission from the company.
            </li>
          </ul>
        </div>

        <!-- Limitation of Liability -->
        <div class="border-l-4 border-[var(--primary)] pl-4">
          <h3 class="text-xl font-semibold text-gray-800 mb-2">
            Limitation of Liability
          </h3>
          <ul class="list-disc pl-6 space-y-2">
            <li>We are not liable for any indirect or incidental damages.</li>
            <li>We are not responsible for any loss of data or profits.</li>
            <li>
              We are not liable for issues caused by third-party services.
            </li>
          </ul>
        </div>

        <!-- Footer -->
        <p class="text-sm text-gray-500 pt-4 border-t">
          Last updated: January 2026
        </p>
      </div>
    </div>
  </div>
</div>
